export function isBlockedUserAgent() {
  if (typeof navigator === "undefined") return true;

  const ua = navigator.userAgent;

  // block empty / missing UA
  if (!ua || ua.trim() === "") return true;

  // known bots / crawlers
  const botRegex =
    /bot|crawler|spider|headless|ahrefsbot|googlebot|bingbot|bytespider|semrush|yandex|duckduckbot/i;

  return botRegex.test(ua);
}
